import React from 'react';
import './style.css';
export default function Counter({
  backgroundColor,
  Icon,
  count,
  title,  
}) {
  return (
    <>
      <div className="countereMain text-center h-100">
        <div className='counter-header' style={{ backgroundColor }}>
          <p className="text-white mb-0 counterTitleText">{title}</p>
        </div>

        <div className='counter-body' style={{ backgroundColor }}>
          <div className="counterTitle">{Icon}</div>
          <h1 className='mb-1 text-white'>{count}</h1>
        </div>

      </div>
    </>
  );
}
